import { datadogRum } from '@datadog/browser-rum';
import { Box } from '@spark-web/box';
import { ButtonLink } from '@spark-web/button';
import { Heading } from '@spark-web/heading';
import { Stack } from '@spark-web/stack';
import { CUSTOMER_PORTAL, getCustomerPortalUrl } from '../../utils';
import { ApplicationSubmissionStatus } from './types';

type CustomerPortalCardProps = {
  readonly applicationStatus: ApplicationSubmissionStatus;
};

function CustomerPortalCard({ applicationStatus }: CustomerPortalCardProps) {
  const handleClick = () => {
    datadogRum.addAction('customer_portal_handoff_started', { applicationStatus });
  };

  return (
    <Box background="primaryLow" borderRadius="medium" padding={{ mobile: 'xlarge', tablet: 'xxlarge' }}>
      <Stack gap="xlarge">
        <Stack gap={{ mobile: 'large', tablet: 'xlarge' }}>
          <Heading level="3">{CUSTOMER_PORTAL.HEADING}</Heading>
          {CUSTOMER_PORTAL.DESCRIPTION}
        </Stack>
        <Box display="flex" justifyContent="start">
          <ButtonLink
            href={getCustomerPortalUrl()}
            onClick={handleClick}
            rounded
            target="_blank"
            rel="noreferrer"
            data={{ testId: 'go-to-customer-portal' }}
          >
            {CUSTOMER_PORTAL.GO_TO_CUSTOMER_PORTAL}
          </ButtonLink>
        </Box>
      </Stack>
    </Box>
  );
}

export default CustomerPortalCard;
